import { useTranslation } from 'next-i18next';
import StationCard from '../stations/StationCard';

export default function DestionationStationListSection({
	destination,
	stations,
}) {
	const { t } = useTranslation(['destination', 'common']);

	return (
		<div className="bg-white py-10 sm:py-14">
			<div className="mx-auto max-w-7xl space-y-6 px-4 lg:px-8">
				<div className="mx-auto max-w-3xl sm:text-center">
					<h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
						{t('destination:stations.title', {
							destination: destination.shortName,
						})}
					</h2>
					<h3 className="mt-6 text-lg leading-8 text-gray-600">
						{t('destination:stations.subtitle', {
							destination: destination.shortName,
						})}
					</h3>
				</div>
				{stations.map((station, index) => (
					<StationCard station={station} key={station.id} />
				))}
			</div>
		</div>
	);
}
